/**
 * Outlook Add-in Agent Panel Configuration
 *
 * Defines the quick actions and default settings for the Agent Panel
 * when used within Microsoft Outlook.
 */

import type { AgentPanelConfig, AgentQuickAction } from '@templatean/shared/types'

/**
 * Outlook-specific quick actions for the Agent Panel
 * These actions are optimized for email composition and communication workflows
 */
export const outlookQuickActions: AgentQuickAction[] = [
  {
    id: 'outlook-email-templates',
    label: 'Email Templates',
    icon: 'mail',
    skillSlug: 'dimi-populate-template',
    agentId: undefined, // Will use Dimi agent
  },
  {
    id: 'outlook-quick-response',
    label: 'Quick Response',
    icon: 'reply',
    skillSlug: 'sia-adjust-tone',
    agentId: undefined, // Will use Sia agent
  },
  {
    id: 'outlook-improve-email',
    label: 'Improve Email',
    icon: 'sparkles',
    skillSlug: 'sia-improve-text',
    agentId: undefined, // Will use Sia agent
  },
  {
    id: 'outlook-find-attachments',
    label: 'Find Attachments',
    icon: 'paperclip',
    skillSlug: 'alex-find-content',
    agentId: undefined, // Will use Alex agent
  },
  {
    id: 'outlook-schedule-meeting',
    label: 'Schedule Meeting',
    icon: 'calendar',
    skillSlug: 'dimi-build-document',
    agentId: undefined, // Will use Dimi agent
  },
]

/**
 * Agent Panel configuration for the Outlook Add-in
 */
export const outlookAgentPanelConfig: AgentPanelConfig = {
  documentType: 'outlook',
  quickActions: outlookQuickActions,
  defaultAgentId: undefined, // No default agent - user selects from available agents
}

export default outlookAgentPanelConfig
